import React from 'react';
import PropTypes from 'prop-types';

import IconArrowLeft from '@spothero/icons/arrow-left';
import {Button, DrawerCloseButton, DrawerHeader, Icon} from '@spothero/ui';

const backButtonStyleProps = {
    variant: 'tertiary',
    color: 'black',
    padding: 2,
    _hover: {color: 'black', background: 'gray.100'},
    _focus: {outlineColor: 'transparent', boxShadow: 'outline'},
};

const closeButtonStyleProps = {
    color: 'black',
    fontSize: 'base',
    _focus: {outlineColor: 'transparent', boxShadow: 'outline'},
};

const MobileNavigationHeader = ({onBackButtonClick, showBackButton}) => {
    return (
        <DrawerHeader
            minHeight={20}
            {...(!showBackButton && {justifyContent: 'flex-end'})}
        >
            {showBackButton && (
                <Button
                    onClick={onBackButtonClick}
                    leftIcon={<Icon as={IconArrowLeft} />}
                    {...backButtonStyleProps}
                >
                    Back
                </Button>
            )}
            <DrawerCloseButton {...closeButtonStyleProps} />
        </DrawerHeader>
    );
};

MobileNavigationHeader.propTypes = {
    onBackButtonClick: PropTypes.func,
    showBackButton: PropTypes.bool,
};

export default MobileNavigationHeader;
